var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUAngleLeftB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49922 12.7998L14.1992 18.3998C14.5992 18.7998 15.1992 18.7998 15.5992 18.3998C15.9992 17.9998 15.9992 17.3998 15.5992 16.9998L10.6992 11.9998L15.5992 6.9998C15.9992 6.5998 15.9992 5.9998 15.5992 5.5998C15.3992 5.3998 15.1992 5.2998 14.8992 5.2998C14.5992 5.2998 14.3992 5.3998 14.1992 5.5998L8.49922 11.1998C8.09922 11.6998 8.09922 12.2998 8.49922 12.7998C8.49922 12.6998 8.49922 12.6998 8.49922 12.7998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUAngleLeftB);
export default __webpack_public_path__ + "static/media/u_angle-left-b.cab570ec10996643176528beaea9f313.svg";
export { ForwardRef as ReactComponent };